/** Legacy orange brand (Exacc / default) */
export const DEFAULT_BRAND = {
  light: {
    main: "#E9702C",
    hover: "#D65F1C",
    chartLight: "#FF8A50",
    chartMuted: "#FFAB91",
    surfaceTint: "#FFF5F0",
    lightTint: 0.08,
    darkTint: 0.3,
    requiredBorderAlpha: 0.6,
    actionActiveAlpha: 0.3,
  },
  dark: {
    main: "#FF9152",
    hover: "#FFA877",
    chartLight: "#FFB380",
    chartMuted: "#FF8A65",
    surfaceTint: "#FFF5F0",
    lightTint: 0.08,
    darkTint: "#FFA877",
    requiredBorderAlpha: 0.7,
    actionActiveAlpha: 0.3,
    actionActiveBase: "#A24511",
    contrastText: "#000000",
  },
};

/** Jim's Soft tenant — blue brand (#005BAE primary, #EAF5FF surface). */
export const JIMSSOFT_BRAND = {
  light: {
    main: "#005BAE",
    hover: "#004992",
    chartLight: "#4A9FD9",
    chartMuted: "#B3D9F5",
    surfaceTint: "#EAF5FF",
    lightTint: 0.08,
    darkTint: 0.3,
    requiredBorderAlpha: 0.6,
    actionActiveAlpha: 0.3,
  },
  dark: {
    main: "#6DB3F0",
    hover: "#8FC5F5",
    chartLight: "#8FC5F5",
    chartMuted: "#A8D4F5",
    surfaceTint: "#0D2440",
    lightTint: 0.08,
    darkTint: "#8FC5F5",
    requiredBorderAlpha: 0.7,
    actionActiveAlpha: 0.3,
    actionActiveBase: "#003D78",
  },
};

/** IPA Soft tenant — navy + cyan (#0D2C6C primary, #48C6EC accent). */
export const IPASOFT_BRAND = {
  light: {
    main: "#0D2C6C",
    hover: "#0A2456",
    chartLight: "#48C6EC",
    chartMuted: "#B3E8F7",
    surfaceTint: "#E8F7FC",
    lightTint: 0.08,
    darkTint: 0.3,
    requiredBorderAlpha: 0.6,
    actionActiveAlpha: 0.3,
  },
  dark: {
    main: "#48C6EC",
    hover: "#6DD4F0",
    chartLight: "#48C6EC",
    chartMuted: "#7AD4EE",
    surfaceTint: "#0A1F3D",
    lightTint: 0.08,
    darkTint: "#6DD4F0",
    requiredBorderAlpha: 0.7,
    actionActiveAlpha: 0.3,
    actionActiveBase: "#0D2C6C",
  },
};

const BRAND_PRESETS = {
  default: DEFAULT_BRAND,
  orange: DEFAULT_BRAND,
  jimssoft: JIMSSOFT_BRAND,
  ipasoft: IPASOFT_BRAND,
};

export function resolveBrandPalette(presetKey) {
  if (!presetKey || presetKey === "default") {
    return DEFAULT_BRAND;
  }
  return BRAND_PRESETS[presetKey] ?? DEFAULT_BRAND;
}

export function getBrandMode(brand, isDarkMode) {
  return isDarkMode ? brand.dark : brand.light;
}

export function hexToRgb(hex) {
  const normalized = hex.replace("#", "");
  return [
    Number.parseInt(normalized.slice(0, 2), 16),
    Number.parseInt(normalized.slice(2, 4), 16),
    Number.parseInt(normalized.slice(4, 6), 16),
  ];
}

export function brandRgba(hex, alpha) {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Required-field border uses light-mode main RGB in both themes (legacy behaviour). */
export function getRequiredBorderColor(brand, isDarkMode) {
  const mode = getBrandMode(brand, isDarkMode);
  const base = isDarkMode ? brand.light.main : mode.main;
  return brandRgba(base, mode.requiredBorderAlpha);
}

export function getHoverBackgroundAlpha(isDarkMode) {
  return isDarkMode ? 0.3 : 0.08;
}
